<div class="mona-hey-button" mat-ripple>
    <mat-icon class="mona-hey-button__icon">mic</mat-icon>
    <span class="mona-hey-button__text"><ng-content></ng-content></span>
</div>
